export const isPaymentComplete = order => {
  if (!order) return false
  if (order.paidStatus === 'done') return true
  if (order.isTableOrderV2) {
    if (order.deliveryType === 'serve' && order.payInTable) return true
    if (order.deliveryType === 'serve' && order.isTablePaidOnline) return true
  } else {
    if (order.paidStatus === 'toCharge' && order.orderStatus === 'done') return true
  }
  return false
}

export const isOrderDone = order => {
  return order.orderStatus === 'done'
}

export const isOrderCancelled = order => {
  return order.orderStatus === 'cancelled'
}

export const isOrderComplete = order => {
  return isOrderDone(order) || isOrderCancelled(order)
}

export const requestedPos = table => {
  return table.request && table.request.action === 'pos' && table.tableTotal > 0
}
